import { useEffect, useState } from 'react';
import type { ReactElement } from 'react';
import { BottomNav, TAB_IDS } from './components/BottomNav';
import type { Tab } from './components/BottomNav';
import { RtpBar } from './components/RtpBar';
import { Dashboard } from './screens/Dashboard';
import { Generator } from './screens/Generator';
import { Grids } from './screens/Grids';
import { Method } from './screens/Method';
import { Stats } from './screens/Stats';

function tabFromHash(): Tab {
  const raw = window.location.hash.replace('#', '');
  return (TAB_IDS as readonly string[]).includes(raw) ? (raw as Tab) : 'dashboard';
}

export function App(): ReactElement {
  const [tab, setTab] = useState<Tab>(tabFromHash);

  // The hash keeps the iOS back gesture working inside the standalone shell.
  useEffect(() => {
    const onHash = (): void => setTab(tabFromHash());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const go = (next: Tab): void => {
    window.location.hash = next;
    setTab(next);
    window.scrollTo({ top: 0 });
  };

  return (
    <div className="app">
      <RtpBar />
      <main>
        {tab === 'dashboard' && <Dashboard />}
        {tab === 'grids' && <Grids />}
        {tab === 'generator' && <Generator />}
        {tab === 'stats' && <Stats />}
        {tab === 'method' && <Method />}
      </main>
      <BottomNav active={tab} onChange={go} />
    </div>
  );
}
